module.exports = __webpack_public_path__ + "media/images/how_it_works/1-5c769046185d5bcf8e5a984d80a95a76.svg";